import React from "react";

export default function About() {
  return (
    <div className="cm-container py-14">
      <div className="max-w-3xl">
        <div className="cm-eyebrow mb-2">About</div>
        <h1 className="cm-h2">Rethinking the first step of care.</h1>
        <p className="cm-body mt-3">CAREMatch was built by clinicians and technologists who believe the hardest part of healthcare shouldn't be figuring out where to start. Our platform pairs AI-assisted navigation with verified doctors, so patients get to the right consultation faster &mdash; and clinicians spend more time on care.</p>
        <p className="cm-body mt-4">We're not a diagnostic tool. We're a trusted guide. Every clinical decision stays where it belongs: with qualified healthcare professionals.</p>
      </div>
    </div>
  );
}
